import { gql } from '@apollo/client'
import { PHOTO_DETAIL_FIELDS } from '../fragments/photoDetail.gql'

export const GET_QUESTION_CREATE_QUESTIONBANK_CONTENT_DETAIL_QUERY = gql`
    # Write your query or mutation here
    query getQuestionBankContentDetailById($id: String!) {
        questionBankGet(id: $id) {
            isSuccess
            errorMessage
            code
            data {
                id
                name
                subject
                examSystem
                chapters {
                    id
                    name
                    questionTypes {
                        id
                        name
                        questionGroups {
                            id
                            name
                        }
                    }
                }
                conceptCards {
                    id
                    name
                    photo {
                        ...photoDetail
                    }
                    chapterId
                    tags {
                        id
                        name
                    }
                }
                tags {
                    id
                    name
                }
            }
        }
    }

    ${PHOTO_DETAIL_FIELDS}
`
